<template>
  <v-card class="ptp-warning">
    <v-subheader class="ptp-warning__header">
      <v-icon medium color="error" class="mr-2">warning</v-icon>
      {{date}} <span class="ml-2">Получено предупреждение на уровне {{level}}</span>
    </v-subheader>
    <v-layout row>
      <v-flex>
        <v-card tile flat class="grey lighten-4">
          <v-card-text>
            <span class="font-weight-medium">Причина: </span>{{reason}}
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs2>
        <v-card tile flat class="grey lighten-3">
          <v-card-text>
            <span class="font-weight-medium">Задание: </span>{{task}}
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs3>
        <v-card tile flat class="grey lighten-4">
          <v-card-text>
            <span class="font-weight-medium">Скрытое предупреждение: </span>
            <span v-if="hidden == 1">да</span>
            <span v-else>нет</span>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
  export default {
    name: "Warning",
    props: ["date", "description", "level", "reason", "task", "hidden"]
  }
</script>

<style scoped>
  .ptp-warning {
    border: 1px solid #78909C;
  }
</style>